export default __webpack_public_path__ + "static/media/simpsons-square.bc2d7bcb.png";